var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "userForm",
      attrs: {
        "hide-footer": "",
        title:
          _vm.modalAction === "add"
            ? _vm.$t("form.title.add")
            : _vm.$t("form.title.edit"),
        "no-close-on-backdrop": ""
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "b-form",
        {
          attrs: { onsubmit: "return false" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validateBeforeSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.email")
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                attrs: { name: "email" },
                model: {
                  value: _vm.user.Email,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "Email", $$v)
                  },
                  expression: "user.Email"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("email")
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errors.first("email")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.firstname")
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "first_name" },
                model: {
                  value: _vm.user.FirstName,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "FirstName", $$v)
                  },
                  expression: "user.FirstName"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("first_name")
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errors.first("first_name")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.middlename"),
                description: _vm.$t("form.descriptions.optional")
              }
            },
            [
              _c("b-form-input", {
                model: {
                  value: _vm.user.MiddleName,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "MiddleName", $$v)
                  },
                  expression: "user.MiddleName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.lastname")
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "last_name" },
                model: {
                  value: _vm.user.LastName,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "LastName", $$v)
                  },
                  expression: "user.LastName"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("last_name")
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errors.first("last_name")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.country")
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "country" },
                model: {
                  value: _vm.user.Country,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "Country", $$v)
                  },
                  expression: "user.Country"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("country")
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errors.first("country")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.company")
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "company" },
                model: {
                  value: _vm.user.CompanyName,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "CompanyName", $$v)
                  },
                  expression: "user.CompanyName"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("company")
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errors.first("company")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.role === "EllipseAdmin"
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    horizontal: "",
                    "label-cols": 4,
                    breakpoint: "md",
                    label: _vm.$t("form.fields.permissions")
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true, is_not: undefined },
                          expression: "{ required: true, is_not: undefined }"
                        }
                      ],
                      staticClass: "mb-3",
                      attrs: { name: "role" },
                      model: {
                        value: _vm.user.Role,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "Role", $$v)
                        },
                        expression: "user.Role"
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { disabled: "" },
                          domProps: { value: undefined }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("form.options.permissions.select"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "EllipseAdmin" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("form.options.permissions.ellipseadmin")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "EllipseTech" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("form.options.permissions.ellipsetech"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "CreditDistributor" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("form.options.permissions.creditdistributor")
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("role"),
                          expression: "errors.has('role')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("role")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.password")
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value:
                      (_vm.modalAction === "add" ? "required|" : "") +
                      "min:6|max:72|verify_password",
                    expression:
                      "(modalAction === 'add' ? 'required|' : '') + 'min:6|max:72|verify_password'"
                  }
                ],
                ref: "password",
                attrs: { type: "password", name: "password" },
                model: {
                  value: _vm.user.Password,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "Password", $$v)
                  },
                  expression: "user.Password"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("password")
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errors.first("password")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 4,
                breakpoint: "md",
                label: _vm.$t("form.fields.repeatPassword")
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value:
                      (_vm.modalAction === "add" ? "required|" : "") +
                      "confirmed:password",
                    expression:
                      "(modalAction === 'add' ? 'required|' : '') + 'confirmed:password'"
                  }
                ],
                attrs: { type: "password", name: "repeatPassword" },
                model: {
                  value: _vm.user.repeatPassword,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "repeatPassword", $$v)
                  },
                  expression: "user.repeatPassword"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("repeatPassword")
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errors.first("repeatPassword")))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.role === "EllipseAdmin"
            ? _c(
                "div",
                [
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        horizontal: "",
                        "label-cols": 4,
                        breakpoint: "md",
                        label: _vm.$t("form.fields.referenceuser"),
                        description: _vm.$t("form.descriptions.referenceuser")
                      }
                    },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          }
                        ],
                        attrs: { name: "referenceusername" },
                        model: {
                          value: _vm.user.ReferenceUser.ReferenceUsername,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.user.ReferenceUser,
                              "ReferenceUsername",
                              $$v
                            )
                          },
                          expression: "user.ReferenceUser.ReferenceUsername"
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.has("referenceusername")
                        ? _c("span", { staticClass: "error" }, [
                            _vm._v(
                              _vm._s(_vm.errors.first("referenceusername"))
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        horizontal: "",
                        "label-cols": 4,
                        breakpoint: "md",
                        label: _vm.$t("form.fields.maxcredit")
                      }
                    },
                    [
                      _c("b-form-input", {
                        model: {
                          value: _vm.user.Limits.MaxCredits,
                          callback: function($$v) {
                            _vm.$set(_vm.user.Limits, "MaxCredits", $$v)
                          },
                          expression: "user.Limits.MaxCredits"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        horizontal: "",
                        "label-cols": 4,
                        breakpoint: "md",
                        label: _vm.$t("form.fields.mintime"),
                        description: _vm.$t("form.descriptions.days")
                      }
                    },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "min_value:1",
                            expression: "'min_value:1'"
                          }
                        ],
                        attrs: { name: "mintime" },
                        model: {
                          value: _vm.user.Limits.MinTime,
                          callback: function($$v) {
                            _vm.$set(_vm.user.Limits, "MinTime", $$v)
                          },
                          expression: "user.Limits.MinTime"
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.has("mintime")
                        ? _c("span", { staticClass: "error" }, [
                            _vm._v(_vm._s(_vm.errors.first("mintime")))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        horizontal: "",
                        "label-cols": 4,
                        breakpoint: "md",
                        label: _vm.$t("form.fields.maxtime"),
                        description: _vm.$t("form.descriptions.days")
                      }
                    },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "min_value:" + _vm.minTimeValue,
                            expression: "`min_value:${minTimeValue}`"
                          }
                        ],
                        attrs: { name: "maxtime" },
                        model: {
                          value: _vm.user.Limits.MaxTime,
                          callback: function($$v) {
                            _vm.$set(_vm.user.Limits, "MaxTime", $$v)
                          },
                          expression: "user.Limits.MaxTime"
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.has("maxtime")
                        ? _c("span", { staticClass: "error" }, [
                            _vm._v(_vm._s(_vm.errors.first("maxtime")))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { type: "submit", variant: "outline-success", block: "" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.modalAction === "add"
                      ? _vm.$t("buttons.save")
                      : _vm.$t("buttons.update")
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6da6d0cd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6da6d0cd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/UserModal.vue
// module id = 776
// module chunks = 0